// import { ScrollScene } from 'scrollscene'
//
// const domNode = document.querySelector('#element')
// const anotherDomNode = document.querySelector('#element2')
//
// const scrollScene = new ScrollScene({
//   triggerElement: domNode,
//   toggle: {
//     element: anotherDomNode,
//     className: 'turn-blue',
//   },
// })


import lottie from 'lottie-web';




let anim2 = lottie.loadAnimation({
  container: document.getElementById('lottie-animation-2'), // the dom element that will contain the animation
  // renderer: "html",
  loop: true,
  autoplay: true,
  path: 'https://assets5.lottiefiles.com/private_files/lf30_osjig8gm.json' // the path to the animation json
});


let anim1 = lottie.loadAnimation({
  container: document.getElementById('lottie-animation-1'), // the dom element that will contain the animation
  // renderer: "html",
  loop: true,
  autoplay: true,
  path: 'https://assets1.lottiefiles.com/private_files/lf30_s453rvci.json' // the path to the animation json
});






// import 'regenerator-runtime/runtime';
import { ScrollObserver } from 'scrollscene';

document.addEventListener("DOMContentLoaded", function(event) {
  // var allVideo = $('.dc-video');
  // var allVideo = document.querySelectorAll('.dc-video');
  var allVideo = document.querySelectorAll('.js-video video');







  for (let z = 0; z < allVideo.length; z++) {
  // allVideo.each(function () {




    let th = $(allVideo[z]);
    let videoTagDomNode = th[0];


    let attrTime = th.closest('.js-video').attr('data-time');
    if (typeof attrTime !== 'undefined' && attrTime !== false && attrTime.trim() !== '') {
      let newSrc = $(videoTagDomNode).attr('src')+'#t='+th.closest('.js-video').attr('data-time');
      $(videoTagDomNode).attr('src', newSrc);
      console.log('tst');
    }




    console.log(th, 'th');
    let arrSrcSplit = $(videoTagDomNode).attr('src').split('#t=');
    let arrStartEndVideo = arrSrcSplit.length > 1 ? arrSrcSplit[1].split(',') : null;
    console.log(arrStartEndVideo);

      let video1Duration;
      let video1Pos;
      let videoCurrentPosition = 0;
      let timer;
      let videoWrap = $(videoTagDomNode).closest('.js-video-wrap');
      let icon = videoWrap.find('.js-icon');
      let boxContent = videoWrap.find('.js-arrow-content');
      let arrPos;
      let direction = null;
      let fl = false;

    // if (th.closest('.js-video').attr('data-changearrow').trim() !== '') {
    let attrChangeArrowTime = th.closest('.js-video').attr('data-changearrow');
    if (typeof attrChangeArrowTime !== 'undefined' && attrChangeArrowTime !== false && attrChangeArrowTime.trim() !== '') {
      // let newChangeArrowTiming = $(videoTagDomNode).attr('data-changearrow');
      $(videoTagDomNode).attr('data-changearrow', attrChangeArrowTime);
      console.log(attrChangeArrowTime, 'attrChangeArrowTime');
      arrPos = th.attr('data-changearrow').split(',');
      console.log(arrPos);
      direction = arrPos[arrPos.length-1].trim() == 'horizontal' ? 'left' : 'top';
      console.log(direction);
    }

      // if (th.attr('data-changearrow')) {
      //
      // }



      console.log(videoTagDomNode);
      videoTagDomNode.addEventListener( "loadeddata", function() {
        // video1Duration = videoTagDomNode.duration;
        video1Duration = arrStartEndVideo ? (arrStartEndVideo[1] - arrStartEndVideo[0]) : videoTagDomNode.duration;
        console.log(video1Duration, 'onloadmeta');

        const scrollObserver = new ScrollObserver({
          triggerElement: videoTagDomNode,
          video: {
            element: videoTagDomNode,
            playingClassName: 'is-playing',
            pausedClassName: 'is-paused',
          },
          callback: {
            active: () => {
              // console.log('active');

              if (videoTagDomNode.hasAttribute('data-changearrow')) {

                  video1Pos = videoTagDomNode.currentTime;

                            timer = setInterval(function () {
                              if (video1Duration) {
                                console.log(video1Duration);
                                videoCurrentPosition = videoTagDomNode.currentTime;
                                // console.log(videoCurrentPosition);

                                if (videoCurrentPosition >= parseInt(arrPos[0]) && videoCurrentPosition < parseInt(arrPos[1]) ) {
                                  icon.css(direction, boxContent.eq(1).position()[direction] - 6);
                                } else if (videoCurrentPosition >= parseInt(arrPos[1]) && videoCurrentPosition <= parseInt(video1Duration) ) {
                                  icon.css(direction, boxContent.eq(2).position()[direction] - 6);
                                } else {
                                  icon.css(direction, boxContent.eq(0).position()[direction] - 6);
                                }
                                if (parseInt(video1Duration) < videoCurrentPosition) {
                                  videoCurrentPosition = 0;
                                }
                              }
                            }, 200);



              } // end if

              if (arrStartEndVideo) {

                console.log(video1Duration);
                timer = setInterval(function () {
                  if (video1Duration) {
                    videoCurrentPosition += 1/10;
                    if (+videoCurrentPosition.toFixed(2) >= video1Duration - 0.4) {
                      videoCurrentPosition = 0;
                      videoTagDomNode.currentTime = arrStartEndVideo[0];
                      videoTagDomNode.play();
                      console.log('more videoDuration');
                    }
                  }
                }, 100);


              }

            },
            notActive: () => {
              if (videoTagDomNode.hasAttribute('data-changearrow')) {
                clearTimeout(timer);
              }
              if (arrStartEndVideo) {
                clearTimeout(timer);
              }
              // console.log('not active');
            }
          },

        });


      });







  };

  });





// scrollObserver.Scene.on('enter', function(event) {
//   console.log('Scene entered.')
// });